import URI from 'jsuri';

import { extractItemSlugAndId } from 'bundles/video-logged-out-page/utils/utils';

type VlpVideoParams = {
  courseSlug: string;
  itemId: string;
  startAt?: number | string;
};

// @ts-expect-error ts-migrate(2322) FIXME: Type '(url: string) => { courseSlug: string; itemI... Remove this comment to see the full error message
const getVlpVideoParamsFromUrl: (url: string) => VlpVideoParams = (url) => {
  let itemId;
  const vlpUri = new URI(url);
  const startAt = vlpUri.getQueryParamValues('startAt')[0];
  const [, , courseSlug, itemSlugAndId] = vlpUri.path().toString().split('/');
  // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const itemSlugAndIdTuple = extractItemSlugAndId(itemSlugAndId);

  if (Array.isArray(itemSlugAndIdTuple)) {
    itemId = itemSlugAndIdTuple[1];
  }

  return {
    courseSlug,
    itemId,
    startAt,
  };
};

export default getVlpVideoParamsFromUrl;
